import { ICountdown } from '@kaaja/data-models';
import {
  Locale,
  format as dateFnsFormat,
  parseISO as dateFnsParseISO,
  differenceInSeconds,
} from 'date-fns';
import { enUS, it } from 'date-fns/locale';
import { Locales } from '../../../tbd/old-routing';

const mapLocaleToDateFnsLocale = (locale: Locales) => {
  switch (locale) {
    case 'en':
      return enUS;
    default:
      return it;
  }
};

const mapToLocale = (locale: Locales): { locale: Locale } => ({
  locale: mapLocaleToDateFnsLocale(locale),
});

export const formatDate = (datetime: string): string => {
  const date = parseISO(datetime);
  return `${dateFnsFormat(date, 'dd.MM.yyyy')}`;
};

export const formatTime = (datetime: string): string => {
  const date = parseISO(datetime);
  return `${dateFnsFormat(date, 'HH.mm')}`;
};

export const getDifferenceInSeconds = (
  firstDate: string | Date,
  secondDate: Date
): number => {
  const from = typeof firstDate === 'string' ? parseISO(firstDate) : firstDate;
  return differenceInSeconds(from, secondDate);
};

export const getCountdown = (from: Date, to: Date): ICountdown => {
  const diffInSeconds = getDifferenceInSeconds(to, from);
  if (diffInSeconds <= 0) {
    return { started: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const d = 60 * 60 * 24;
  const h = 60 * 60;
  const m = 60;

  const days = Math.floor(diffInSeconds / d);
  let remainder = diffInSeconds % d;
  const hours = Math.floor(remainder / h);
  remainder = diffInSeconds % h;
  const minutes = Math.floor(remainder / m);
  const seconds = remainder % m;

  return { started: true, days, hours, minutes, seconds };
};

export const formatDateTime = (
  datetime: Date,
  dateFormat = 'dd.MM.yyyy HH.mm'
): string => dateFnsFormat(datetime, dateFormat);
export const format = (
  datetime: Date,
  dateFormat: string,
  locale: Locales
): string => dateFnsFormat(datetime, dateFormat, mapToLocale(locale));

export const parse = (date: string): Date => {
  console.log('DATA IN ARRIVO', date);
  const split = date.split(' ');
  const dateParts = split[0].split('-');
  const years = parseInt(dateParts[0], 10) || 0;
  const months = parseInt(dateParts[1], 10) - 1 || 0;
  const days = parseInt(dateParts[2], 10) || 0;

  const time = split[1];
  const hours = parseInt(time.split(':')[0], 10) || 0;
  const minutes = parseInt(time.split(':')[1], 10) || 0;
  const seconds = parseInt(time.split(':')[2], 10) || 0;
  return new Date(Date.UTC(years, months, days, hours, minutes, seconds));
};

export const parseISO = dateFnsParseISO;
